import { RouteObject } from '@rocketlane/rocket-router';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';

export const projectRoutes: RouteObject = {
  path: ROUTE_PATHS.PROJECTS,
  children: [
    {
      path: ROUTE_PATHS.PROJECT_CREATE,
      caseSensitive: true,
      async lazy() {
        const { CreatePageRenderer } = await retryImportInsideRoutesDefinition(
          () => import('./create-page-renderer'),
        );

        return {
          element: <CreatePageRenderer />,
        };
      },
    },
    {
      path: `${ROUTE_PATHS.EMPTY}`,
      caseSensitive: true,
      async lazy() {
        const { ProjectListV2Page } = await retryImportInsideRoutesDefinition(
          () => import('./list-v2'),
        );

        return {
          element: <ProjectListV2Page />,
        };
      },
    },
    {
      path: `${ROUTE_PATHS.PROJECT_ID}/${ROUTE_PATHS.MATCH_ALL}`,
      async lazy() {
        const { ProjectDetailRoute } = await retryImportInsideRoutesDefinition(
          () => import('./detail'),
        );

        return {
          element: (
            <SecureRoute>
              <ProjectDetailRoute />
            </SecureRoute>
          ),
        };
      },
      // async lazy() {
      //   const { ProjectDetailRoute } = await retryImportInsideRoutesDefinition(
      //     () => import('./detail'),
      //   );

      //   return {
      //     element: <ProjectDetailRoute />,
      //   };
      // },
    },
  ],
};
